import { render, staticRenderFns } from "./projectView1.vue?vue&type=template&id=4b3278d5&scoped=true"
import script from "./projectView1.vue?vue&type=script&lang=js"
export * from "./projectView1.vue?vue&type=script&lang=js"
import style0 from "./projectView1.vue?vue&type=style&index=0&id=4b3278d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3278d5",
  null
  
)

export default component.exports